define('constants/couchDbEnumeration',[], function() {
    return {
        setToNull : Number.MIN_VALUE
    };
});
